"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumSchemeUrl = void 0;
var EnumSchemeUrl;
(function (EnumSchemeUrl) {
    EnumSchemeUrl["Inmeeting"] = "wemeet://page/inmeeting";
    EnumSchemeUrl["Launch"] = "wemeet://launch";
    EnumSchemeUrl["SchemeAuthSso"] = "wemeet://auth/sso";
})(EnumSchemeUrl = exports.EnumSchemeUrl || (exports.EnumSchemeUrl = {}));
//# sourceMappingURL=scheme.js.map